import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportInvoicePdf } from "../../../redux/sharedSlice";

export const useInvoice = () => {
 const dispatch = useDispatch();
  const { loading, invoiceData, displayInvoice, error } = useSelector(
    (state: any) => state.sharedSlice
  );

  const [numPages, setNumPages] = useState<number | null>(null);

  const fetchInvoice = useCallback(
    (params: any) => {
      dispatch(exportInvoicePdf({ params }));
    },
    [dispatch]
  );

  const handleDocumentLoadSuccess = useCallback((pages: number) => {
    setNumPages(pages);
  }, []);


  return {
    loading,
    invoiceData,
    displayInvoice,
    error,
    numPages,
    fetchInvoice,
    handleDocumentLoadSuccess,
  };
};
